import { render } from "./ImageShadow.vue?vue&type=template&id=65e175e9&scoped=true"
import script from "./ImageShadow.vue?vue&type=script&lang=js"
export * from "./ImageShadow.vue?vue&type=script&lang=js"

import "./ImageShadow.vue?vue&type=style&index=0&id=65e175e9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e175e9"]])

export default __exports__